import React, { Fragment, useCallback } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';

import Heading from '@components-legacy/Heading';
import Paragraph from '@components-legacy/Paragraph';
import { noop } from '@constants/general';
import UploadIcon from '@resources/svgs/button_upload.svg';

import styles from './DropZone.scss';

const DropZone = ({ onDropComplete, acceptedList }) => {
  const onDrop = useCallback(
    (acceptedFiles, rejectedFiles) => {
      // Do something with the files
      acceptedFiles.forEach(file => {
        const reader = new FileReader();
        // eslint-disable-next-line no-console
        reader.onabort = () => console.log('file reading was aborted');
        // eslint-disable-next-line no-console
        reader.onerror = () => console.log('file reading has failed');
        reader.onload = () => {
          // Do whatever you want with the file contents
        };

        reader.readAsArrayBuffer(file);
      });

      acceptedFiles.length > 0 && onDropComplete(acceptedFiles);
      rejectedFiles.length > 0 &&
        // eslint-disable-next-line no-alert
        alert(`Sorry, only the following file types are allowed: ${acceptedList}`);
    },
    [onDropComplete]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedList,
  });

  const dropZoneClassProps = clsx(styles.dropZone, {
    [styles.dropZoneDragActive]: isDragActive,
  });

  return (
    <div
      {...getRootProps({
        className: dropZoneClassProps,
      })}
    >
      <input {...getInputProps()} />
      <div className={styles.dropZoneBox}>
        {isDragActive ? (
          <Heading level={2}>
            <FormattedMessage
              defaultMessage="Drop the files here ..."
              id="global.actions.drop-files-here"
            />
          </Heading>
        ) : (
          <Fragment>
            <UploadIcon className={styles.dropZoneIcon} />
            <div>
              <Heading level={2}>
                <FormattedMessage defaultMessage="Drag & Drop" id="global.actions.drag-drop" />
              </Heading>
              <Paragraph appearance="light" margin={false}>
                <FormattedMessage
                  defaultMessage="Your files here or"
                  id="global.actions.your-files"
                />{' '}
                <button className={`hyperlink ${styles.browse}`} type="button">
                  <FormattedMessage defaultMessage="browse" id="global.actions.browse" />
                </button>
              </Paragraph>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

DropZone.defaultProps = {
  onDropComplete: noop,
  acceptedList: ['.doc', '.docx', '.pdf', '.xls', '.xlsx', '.csv', '.jpg', '.jpeg', '.png'],
};

DropZone.propTypes = {
  /** On upload complete callback */
  onDropComplete: PropTypes.func,
  /** List of accepted file extensions */
  acceptedList: PropTypes.arrayOf(PropTypes.string),
};

export default DropZone;
